<template>
  <div class="footer">
    <div class="footer-inner">
      <div class="footer-info">
        <span class="company">Unity 合同会社</span>
        <span class="dot">・</span>
        <a id="mail-to" href="mailto:contact@donaru.jp?subject=お問い合わせ">contact@donaru.jp</a>
        <span class="dot">・</span>
        <a class="foot-link" href="/ryoko" target="_blank">旅行業法に基づく表示</a>
      </div>
      <div class="footer-right">
        <div class="footer-social">
          <a href="https://www.facebook.com/groups/3362753157068603/" target="_blank">
            <ion-icon name="logo-facebook"></ion-icon>
          </a>
          <a href="https://www.instagram.com/farmy_shinsyu/" target="_blank">
            <ion-icon name="logo-instagram"></ion-icon>
          </a>
        </div>
        <span class="llc">© 2026 Unity.LLC</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  box-sizing: border-box;
  margin-top: 32px;
  padding: 9px 24px;
  background-color: #AF9453;
  color: antiquewhite;
}
.footer-inner {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px 16px;
  flex-wrap: wrap;
}
.footer-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  text-align: left;
}
.company { font-size: 13px; font-weight: 600; }
.footer-info a,
#mail-to {
  color: antiquewhite;
  font-size: 13px;
  text-decoration: none;
}
.footer-info a:hover { text-decoration: underline; }
.dot { opacity: 0.6; font-size: 11px; }
.footer-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.footer-social {
  display: inline-flex;
  gap: 12px;
}
.footer-social a { color: antiquewhite; }
.footer-social ion-icon { font-size: 20px; vertical-align: middle; }
.llc { font-size: 12px; opacity: 0.9; white-space: nowrap; }
@media screen and (max-width: 640px) {
  .footer-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
</style>
